import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=a8162e14&"
import script from "./Reviews.vue?vue&type=script&lang=ts&"
export * from "./Reviews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductRating: require('/home/vsts/work/1/a/NuxtApp/components/product/Rating.vue').default,ProductReview: require('/home/vsts/work/1/a/NuxtApp/components/product/Review.vue').default,BaseOverlay: require('/home/vsts/work/1/a/NuxtApp/components/base/Overlay.vue').default})
